var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{attrs:{"id":"my-chart-bar","options":_vm.chartOptions,"data":_vm.chartData,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }